import type { EditDetailedSummaryExpensesRequestProps } from '@services/api/otherExpenses/types'
import type { EditDetailedSummaryExpensesModalFormProps } from '../components/modals/EditDetailedSummaryExpenses/form/types'

export const parseEditDetailedSummaryExpensesPayload = (formData: EditDetailedSummaryExpensesModalFormProps) => {
  const payload: EditDetailedSummaryExpensesRequestProps = {
    routeParams: {
      filiCode: formData.filiCode
    },
    bodyParams: {
      referenceDate: formData.competenceDate,
      accountingCode: formData.accountCode,
      accountingDescription: formData.accountDescriptionText || '',
      amount: formData.otherExpensesAmount ? Number(formData.otherExpensesAmount) : 0,
      observations: formData.observations || ''
    }
  }

  return payload
}
